import React from "react";
import PropTypes from "prop-types";
import GenericPlot from "components/Plot/Plot";

const MultiLinePlot = ({
  x,
  series,
  width,
  height,
  xLabel,
  yLabel,
  xAxisRange,
  yAxisRange,
  showLegend
}) => {
  // This component is designed to receive an array of series objects.
  // We map this array into the format Plotly expects for multiple traces.
  const [customxAxisRange, setCustomxAxisRange] = React.useState(null);
  const [customyAxisRange, setCustomyAxisRange] = React.useState(null);

  const handleCustomRange = (xRange, yRange) => {
    setCustomxAxisRange(xRange);
    setCustomyAxisRange(yRange);
  };

  const plotData = series.map(s => ({
    x: s.xData || x,
    y: s.values,
    type: "scatter",
    mode: "lines",
    name: s.name,
    line: s.line
  }));

  const yRange = yAxisRange || [0, 1.05]; // Default MTF range from 0 to 1

  return (
    <GenericPlot
      data={plotData}
      handleCustomRange={handleCustomRange}
      layout={{
        width: width,
        height: height,
        xaxis: {
          title: xLabel,
          range: customxAxisRange ? customxAxisRange : xAxisRange,
          autorange: customxAxisRange ? false : true
        },
        yaxis: {
          title: yLabel,
          range: customyAxisRange ? customyAxisRange : yRange,
          autorange: false,
          automargin: true
        },
        showlegend: showLegend,
        legend: {
          x: 1,
          xanchor: "right",
          y: 1
        },
        margin: { l: 50, r: 50, b: 50, t: 50, pad: 4 }
      }}
    />
  );
};

// Define the expected props for validation and clarity
MultiLinePlot.propTypes = {
  x: PropTypes.array.isRequired,
  series: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      values: PropTypes.array.isRequired,
      line: PropTypes.object
    })
  ).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  xLabel: PropTypes.string,
  yLabel: PropTypes.string,
  xAxisRange: PropTypes.array,
  yAxisRange: PropTypes.array,
  showLegend: PropTypes.bool
};

export default MultiLinePlot;
